export default __webpack_public_path__ + "static/media/IslandInSand.e79dfa97.jpg";